import Header from './Header.vue';

export default Header;



// WEBPACK FOOTER //
// ./src/pages/profile/views/certificate/components/header/index.ts